//models
import { useInfiniteQuery } from '@tanstack/react-query';

import { AttributeQueryParams } from '../../models/contact_attributes.model';

//services
import API from '../../services/api';

//queryKey
import _queryKeys from './_queryKeys';

const getAttribute = async (
    pageParam: number,
    queryParams?: AttributeQueryParams,
) => {
    const { data } = await API.getAttributes({
        ...queryParams,
        page: pageParam,
        per_page: 25,
    });
    return data;
};
export default function useAttributesForSelectQuery(
    queryParams: AttributeQueryParams,
    enabled = true,
) {
    return useInfiniteQuery({
        queryKey: _queryKeys.attributesParamsForSelect(queryParams),
        queryFn: ({ pageParam = 1 }) => getAttribute(pageParam, queryParams),
        initialPageParam: 1,
        staleTime: 1000 * 24 * 60 * 60,
        getNextPageParam: (lastPage: any) => lastPage?.next_page,
        getPreviousPageParam: (lastPage: any) => lastPage?.prev_page,
        enabled: enabled,
    });
}
